module.exports = require("d3");


//////////////////
// WEBPACK FOOTER
// external "d3"
// module id = 28
// module chunks = 0